import { memo } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate } from 'react-router-dom';

import NavLink from '../../NavLink';

function ItemMenu({ item }) {
  const navigate = useNavigate();
  const handleSelect = eventKey => navigate(eventKey);
  return item.elements ? (
    <NavDropdown
      title={item.title}
      id="basic-nav-dropdown"
      className="nav-links"
      menuVariant="dark"
      onSelect={handleSelect}>
      {item.elements.map((item, index) => (
        <NavDropdown.Item
          className="nav-item"
          eventKey={item.path}
          onClick={() => {
            document.querySelector('.navbar-collapse').classList.remove('show');
            document.querySelector('.navbar-toggler').click();
          }}
          key={index}>
          {item.title}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  ) : (
    <NavLink {...item} />
  );
}

export default memo(ItemMenu);
